import { useState } from 'react'
import { MobileContentGems } from '@mc/api'
import { useTranslation } from '@mc/i18n'
import { useStaticData } from '@mc/static-data-react'
import { CM_TIMELINE_VIEW_V2_I18N_NAMESPACE } from '../../../../i18n'
import { Section } from '../../Section'
import { Title } from '../../Title'
import {
  trackViewLessonPlanClicked,
  trackLessonPopoverClosed,
} from '../../events'
import { ContentDesktop } from './ContentDesktop'
import { ContentMobile } from './ContentMobile'
import { LessonPlanPopover } from './LessonPlanPopover'

export const SkillsYoullLearnSection = () => {
  const { t } = useTranslation(CM_TIMELINE_VIEW_V2_I18N_NAMESPACE)
  const { mobileContentGems } = useStaticData<{
    mobileContentGems: MobileContentGems[]
  }>()

  const [isPopoverOpen, setIsPopoverOpen] = useState(false)

  if (!mobileContentGems?.length) {
    return null
  }

  const handleSubtitleClick = () => {
    setIsPopoverOpen(true)
    trackViewLessonPlanClicked()
  }

  const closePopover = () => {
    setIsPopoverOpen(false)
    trackLessonPopoverClosed()
  }

  return (
    <Section noAnimation>
      <div className='row mc-mb-3'>
        <div className='col-12'>
          <Title>{t('variant_1.skillsYoullLearn.title')}</Title>
          <button
            onClick={handleSubtitleClick}
            className='mc-text-h6 mc-p-0 mc-clickable'
          >
            {t('variant_1.skillsYoullLearn.subtitle')}
          </button>
        </div>
      </div>

      <div className='d-none d-sm-block'>
        <ContentDesktop mobileContentGems={mobileContentGems} />
      </div>
      <div className='d-sm-none'>
        <ContentMobile mobileContentGems={mobileContentGems} />
      </div>

      <LessonPlanPopover isOpen={isPopoverOpen} onClose={closePopover} />
    </Section>
  )
}
